import { BootstrapResource, CadNextBootstrapView } from '@mark43/cad-api';
import { TypeBoundAxiosInstance } from '@m43/core';

/**
 * We do this part of bootstrap on the FE and not the backend to avoid
 * a cross-server call, as this data lives within the DEx API.
 */
export const bootstrapDex = async (
    bootstrapView: CadNextBootstrapView,
    apiClient: TypeBoundAxiosInstance
): Promise<CadNextBootstrapView> => {
    if (!bootstrapView.dexRegion) {
        return bootstrapView;
    }

    try {
        const { data } = await apiClient.request<BootstrapResource.GetDexBootstrapInfoForUser>({
            method: 'GET',
            url: 'bootstrap/dex',
        });

        const { oriAliasOptionsView, showDexUserIdentificationError } = data?.data ?? {};
        const oriAliasOptions =
            oriAliasOptionsView?.oriAliases?.map(({ id, isDefault, oriAlias }) => ({
                label: oriAlias,
                value: id,
                isDefault,
            })) ?? [];
        return {
            ...bootstrapView,
            showDexUserIdentificationError: showDexUserIdentificationError ?? false,
            oriAliasOptions,
        };
    } catch (err) {
        return bootstrapView;
    }
};
